export default "__VITE_ASSET__CUPohB99__"